<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="'Phone'">
              <a-input v-model="queryParam.mobileNo"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'registerTime')">
              <a-date-picker v-model="queryParam.registerTime" format="YYYY-MM-DD" style="width: 100%" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="'ProductType'">
              <a-select allowClear v-model="queryParam.appssid">
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="'UnconvertedType'">
              <a-select allowClear default-value="" style="width: 200px" v-model="queryParam.translateStatus">
                <a-select-option :value="0"> Registered Users </a-select-option>
                <a-select-option :value="1"> Registration Not Converted to Personal Info </a-select-option>
                <a-select-option :value="2"> Personal Info Not Converted to Contact Info </a-select-option>
                <a-select-option :value="3"> Contact Info Not Converted to ID Info </a-select-option>
                <a-select-option :value="4"> ID Info Not Converted to Bank Info </a-select-option>
                <a-select-option :value="5"> Bank Info Not Converted to Order </a-select-option>
                <a-select-option :value="6"> Registered No Loan Applied </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-modal v-model="visdialog" title="Customer Detail" width="1000px">
        <a-form :loading="loading" :form="custInfoForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
          <a-form-item>
            <a-button type="primary" @click="handleDetail(previousId)">Previous</a-button>
            <a-button type="primary" @click="handleDetail(nextId)">Next</a-button>
          </a-form-item>
          <a-form-item :label="'id'">
            <div>{{ custInfoForm.id }}</div>
          </a-form-item>
          <a-form-item :label="'Application'">
            <div>{{ custInfoForm.appSsid }}</div>
          </a-form-item>
          <a-form-item :label="'Birthday'">
            <div>{{ custInfoForm.birthday }}</div>
          </a-form-item>
          <a-form-item :label="'Age'">
            <div>{{ custInfoForm.age }}</div>
          </a-form-item>
          <a-form-item :label="'Gender'">
            <div>{{ custInfoForm.sex }}</div>
          </a-form-item>
          <a-form-item :label="'Phone'">
            <div>{{ custInfoForm.mobileNo }}</div>
          </a-form-item>
          <a-form-item :label="'Email'">
            <div>{{ custInfoForm.email }}</div>
          </a-form-item>
          <a-form-item :label="'Channel'">
            <div>{{ custInfoForm.channel }}</div>
          </a-form-item>
          <a-form-item :label="'Face Score'">
            <div>{{ custInfoForm.faceSimilarity }}</div>
          </a-form-item>
          <a-form-item :label="'Face Result'">
            <div>{{ custInfoForm.faceVerified }}</div>
          </a-form-item>
          <a-form-item :label="'gaid'">
            <div>{{ custInfoForm.gaid }}</div>
          </a-form-item>
          <a-form-item :label="'deviceId'">
            <div>{{ custInfoForm.deviceId }}</div>
          </a-form-item>
          <a-form-item :label="'Existing Customer Flag'">
            <div>{{ custInfoForm.reborrowFlag }}</div>
          </a-form-item>
          <a-form-item :label="'Created Time'">
            <div>{{ custInfoForm.createdTime }}</div>
          </a-form-item>
          <a-form-item :label="'Updated Time'">
            <div>{{ custInfoForm.updatedTime }}</div>
          </a-form-item>
          <a-form-item :label="'Data Point'">
            <div v-for="(item, index) in optTypeList" :key="index">
              {{ item.createdAt }}
              {{ item.optType }}
              Phone Brand:{{ item.equipmentBrand }} Phone Model:{{ item.equipmentType }} System Version:{{
                item.osVersion
              }}
              appVersion:{{ item.versionName }} Data:{{ item.data }}
            </div>
          </a-form-item>
        </a-form>
      </a-modal>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="countRateColumns"
        :dataSource="countRateList"
        :rowClassName="rowClassName"
        :pagination="false"
        :loading="loading"
        bordered
      >
      </a-table>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :rowClassName="rowClassName"
        :pagination="false"
        :loading="loading"
        bordered
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record.id, record.appSsid)"> View </a>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import { getAsCountRate, getAsInfo, getOptType } from '@/webpublicapi/translate'
import { getCustById } from '@/webpublicapi/customer'
import { getPartConversionRate } from '@/webpublicapi/home'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
  OPERATION: 'operation.',
}

export default {
  name: 'asinfo',
  components: {
    Dict,
    DictSelect,
    vModal,
  },
  data() {
    return {
      visdialog: false,
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      nextId: undefined,
      previousId: undefined,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      custInfoForm: {
        age: '',
        appSsid: '',
        birthday: '',
        channel: '',
        createdTime: '',
        curp: '',
        deviceId: '',
        email: '',
        faceSimilarity: '',
        faceVerified: '',
        gaid: '',
        id: '',
        mobileNo: '',
        names: '',
        reborrowFlag: '',
        sex: '',
        surnames: '',
        updatedTime: '',
      },
      total: 0,
      dataSource: [],
      appList: [],
      optTypeList: [],
      custInfoIdList: [],
      countRateList: [],
      // Query conditions
      queryParam: {
        appssid: '',
        translateStatus: '',
        mobileNo: '',
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
    }
  },
  computed: {
    countRateColumns() {
      return [
        {
          title: 'UnconvertedReason',
          align: 'left',
          dataIndex: 'transName',
        },
        {
          title: 'Quantity',
          align: 'left',
          dataIndex: 'transCount',
        },
        {
          title: 'Rate',
          align: 'left',
          dataIndex: 'transRate',
        },
      ]
    },
    columns() {
      return [
        {
          title: 'id',
          align: 'left',
          dataIndex: 'id',
        },
        {
          title: 'Phone',
          align: 'left',
          dataIndex: 'mobileNo',
        },
        {
          title: 'Age',
          align: 'left',
          dataIndex: 'age',
        },
        {
          title: 'Gender',
          align: 'left',
          dataIndex: 'sex',
        },
        {
          title: 'Birthday',
          align: 'left',
          dataIndex: 'birthday',
        },
        {
          title: 'Channel',
          align: 'left',
          dataIndex: 'channel',
        },
        {
          title: 'Email',
          align: 'left',
          dataIndex: 'email',
        },
        {
          title: 'Existing Customer Flag',
          align: 'left',
          dataIndex: 'reborrowFlag',
        },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  created() {
    getApplist().then((res) => {
      this.appList = res.data || []
      if (this.appList != null) {
        this.appList.forEach((item) => {
          if (item.appName == 'All') {
            item.appName = 'Please select'
          }
        })
      }
    })
    this.getDict()
  },
  methods: {
    handleDetail(id, appssid) {
      if (id == undefined) {
        this.$message.error('No such recordsData!')
      } else {
        this.visdialog = false
        this.loading = true
        getCustById(id)
          .then((res) => {
            this.custInfoForm = res.data
            this.custInfoForm.birthday = this.transformTime(this.custInfoForm.birthday)
            this.custInfoForm.createdTime = this.transformTimeSecond(this.custInfoForm.createdTime)
            this.custInfoForm.updatedTime = this.transformTimeSecond(this.custInfoForm.updatedTime)
            if (this.custInfoForm.sex == 0) {
              this.custInfoForm.sex = 'Confidential'
            } else if (this.custInfoForm.sex == 1) {
              this.custInfoForm.sex = 'Male'
            } else if (this.custInfoForm.sex == 2) {
              this.custInfoForm.sex = 'Female'
            }
            if (this.custInfoForm.reborrowFlag == 0) {
              this.custInfoForm.reborrowFlag = 'No'
            } else {
              this.custInfoForm.reborrowFlag = 'Yes'
            }
            if (this.custInfoForm.faceVerified == 0) {
              this.custInfoForm.faceVerified = 'notPass'
            } else {
              this.custInfoForm.faceVerified = 'Pass'
            }
          })
          .catch((e) => {
            this.$message.error(e.message)
          })
        getOptType(id, appssid)
          .then((res) => {
            this.optTypeList = res.data
            if (this.optTypeList != null) {
              this.optTypeList.forEach((item) => {
                item.createdAt = this.transformTimeSecond(item.createdAt)

                /*if (item.optType == 'SERVICE_INSTALL') {
                item.optType = 'Install(Attribution)'
              } else if (item.optType.indexOf('SYSTEN_INSTALL') != -1) {
                item.optType = item.optType.replace('SYSTEN_INSTALL', 'Install(PassListenINSTALL_REFERRER ReceiverImplementation)')
              } else if (item.optType.indexOf('SYSTEM_INIT_OPEN') != -1) {
                item.optType = item.optType.replace('SYSTEM_INIT_OPEN', 'OpenAPP')
              } else if (item.optType.indexOf('SYSTEM_HIDE') != -1) {
                item.optType = item.optType.replace('SYSTEM_HIDE', 'HideAPP')
              } else if (item.optType.indexOf('SYSTEM_CLOSE') != -1) {
                item.optType = item.optType.replace('SYSTEM_CLOSE', 'CloseAPP(PassServiceAndListenTriggerTaskListImplementation)')
              } else if (item.optType == 'CLICK_USER_AGREEMENT') {
                item.optType = 'UserAgreementClickAgreeButton'
              } else if (item.optType == 'CLICK_PERMISSION_AGREE') {
                item.optType = 'PermissionCopyAgree'
              } else if (item.optType == 'SYSTEM_PERMISSION_RESULT') {
                item.optType = 'PermissionCopyAuthResult'
              } else if (item.optType == 'CLICK_PERMISSION_SKIP') {
                item.optType = 'PermissionCopySkipped'
              } else if (item.optType == 'CLICK_SEND_OTP') {
                item.optType = 'ClickSendVerification Code(IncludeAutoSend)'
              } else if (item.optType == 'SYSTEM_LOGIN_BACK') {
                item.optType = 'Verification CodeAndLoginSeparateWhen,ClickLoginBackButton'
              } else if (item.optType == 'CLICK_LOGIN') {
                item.optType = 'ClickLogin'
              } else if (item.optType == 'SERVICE_SEND_OTP') {
                item.optType = 'SendVerification CodeSuccess'
              } else if (item.optType == 'FIRST_REGISTER_SUCCESS') {
                item.optType = 'RegistrationSuccess'
              } else if (item.optType == 'SERVICE_FIRST_REGISTER') {
                item.optType = 'RegistrationSuccess'
              } else if (item.optType == 'SERVICE_LOGIN') {
                item.optType = 'LoginSuccess(IncludingRegistration)'
              } else if (item.optType == 'CLICK_LOGOUT') {
                item.optType = 'ClickLogoutLoginButton'
              } else if (item.optType == 'CLICK_INDEX_APPLY') {
                item.optType = 'ClickApplyButton'
              } else if (item.optType == 'CLICK_FIRST_INDEX_APPLY') {
                item.optType = 'MainProductFirst LoanClickApplyButton'
              } else if (item.optType == 'SYSTEM_BASIC_INF_ENTER') {
                item.optType = 'EnterPersonal Info'
              } else if (item.optType == 'SYSTEM_BASIC_INF_LOAD') {
                item.optType = 'Personal InfoDataLoadComplete'
              } else if (item.optType == 'CLICK_BASIC_INF_BOX') {
                item.optType = 'PageNo DisplayPersonal InfoWhen,EnterPage(AndOtherInfoMergeWhenChange toClickFirstInputField)'
              } else if (item.optType == 'CLICK_BASIC_INF_NP') {
                item.optType = 'MainProductFirst LoanPageNo DisplayPersonal InfoWhen,UserFillInfoAfter,ClickSubmitAndPassVerification(AndOtherInfoMergeWhenChange toClickNext StepFirstInputField)'
              } else if (item.optType == 'CLICK_BASIC_INF_SUBMIT') {
                item.optType = 'ClickPersonal InfoSubmitButton'
              } else if (item.optType == 'SYSTEM_BASIC_INF_BACK') {
                item.optType = 'Personal InfoBackPrevious'
              } else if (item.optType == 'SERVICE_SAVE_BASIC_INFO') {
                item.optType = 'SavePersonal Info'
              } else if (item.optType == 'SERVICE_FIRST_SAVE_BASIC_INFO') {
                item.optType = 'MainProductFirst TimeSavePersonal Info'
              } else if (item.optType == 'SYSTEM_WORK_INF_ENTER') {
                item.optType = 'EnterWorkInfo'
              } else if (item.optType == 'SYSTEM_WORK_INF_LOAD') {
                item.optType = 'WorkInfoDataLoadComplete'
              } else if (item.optType == 'CLICK_WORK_INF_BOX') {
                item.optType = 'PageNo DisplayWorkInfoWhen,EnterPage(AndOtherInfoMergeWhenChange toClickFirstInputField)'
              } else if (item.optType == 'CLICK_WORK_INF_NP') {
                item.optType = 'MainProductFirst LoanPageNo DisplayWorkInfoWhen,UserFillInfoAfter,ClickSubmitAndPassVerification(AndOtherInfoMergeWhenChange toClickNext StepFirstInputField)'
              } else if (item.optType == 'CLICK_WORK_INF_SUBMIT') {
                item.optType = 'ClickWorkInfoSubmitButton'
              } else if (item.optType == 'SYSTEM_WORK_INF_BACK') {
                item.optType = 'WorkInfoBackPrevious'
              } else if (item.optType == 'SERVICE_SAVE_WORK_INFO') {
                item.optType = 'SaveWorkInfo'
              } else if (item.optType == 'SERVICE_FIRST_SAVE_WORK_INFO') {
                item.optType = 'MainProductFirst TimeSaveWorkInfo'
              } else if (item.optType == 'SYSTEM_CONTACT_INF_ENTER') {
                item.optType = 'EnterContactInfo'
              } else if (item.optType == 'SYSTEM_CONTACT_INF_LOAD') {
                item.optType = 'ContactInfoDataLoadComplete'
              } else if (item.optType == 'CLICK_CONTACT_INF_BOX') {
                item.optType = 'PageNo DisplayContactInfoWhen,EnterPage(AndOtherInfoMergeWhenChange toClickFirstInputField)'
              } else if (item.optType == 'CLICK_CONTACT_INF_NP') {
                item.optType = 'MainProductFirst LoanPageNo DisplayContactInfoWhen,UserFillInfoAfter,ClickSubmitAndPassVerification(AndOtherInfoMergeWhenChange toClickNext StepFirstInputField)'
              } else if (item.optType == 'CLICK_CONTACT_INF_SUBMIT') {
                item.optType = 'ClickContactSubmitButton'
              } else if (item.optType == 'CLICK_CONTACT_AGREE') {
                item.optType = 'ClickAgreeContactCaptureAuth'
              } else if (item.optType == 'CLICK_CONTACT_CANCEL') {
                item.optType = 'ClickRejectContactCaptureAuth'
              } else if (item.optType == 'SYSTEM_CONTACT_RESULT') {
                item.optType = 'ContactCaptureAuthResult'
              } else if (item.optType == 'CLICK_DEVICE_AGREE') {
                item.optType = 'AgreeDataCaptureAuth'
              } else if (item.optType == 'CLICK_DEVICE_CANCEL') {
                item.optType = 'RejectDataCaptureAuth'
              } else if (item.optType == 'SYSTEM_DEVICE_RESULT') {
                item.optType = 'DataCaptureAuthResult'
              } else if (item.optType == 'SYSTEM_DEVICE_INFO_NP') {
                item.optType = 'MainProductFirst LoanPageNo DisplayContactInfoWhen,CompleteDataCaptureAuth(AllPassWhen)'
              } else if (item.optType == 'SYSTEM_DEVICE_INFO_UPLOAD') {
                item.optType = 'StartUploadDeviceData'
              } else if (item.optType == 'SYSTEM_DEVICE_INFO_SUCCESS') {
                item.optType = 'CompleteUploadDeviceData'
              } else if (item.optType == 'SYSTEM_CONTACT_INF_BACK') {
                item.optType = 'ContactInfoBackPrevious'
              } else if (item.optType == 'CLICK_CONTACT_INF_SUBMIT_T') {
                item.optType = 'UpdateContactInfo(alreadyExistAndChangeWhen)'
              } else if (item.optType == 'SERVICE_SAVE_CONTACT_INFO') {
                item.optType = 'SaveContactInfo'
              } else if (item.optType == 'SERVICE_FIRST_SAVE_CONTACT_INFO') {
                item.optType = 'MainProductFirst TimeSaveContactInfo'
              } else if (item.optType == 'SERVICE_SAVE_DEVICE_INFO') {
                item.optType = 'SubmitDeviceDataSuccess'
              } else if (item.optType == 'SERVICE_FIRST_SAVE_DEVICE_INFO') {
                item.optType = 'MainProductFirst TimeSubmitDeviceDataSuccess'
              } else if (item.optType == 'SYSTEM_ID_INF_ENTER') {
                item.optType = 'EnterIdentityInfo'
              } else if (item.optType == 'SYSTEM_ID_INF_LOAD') {
                item.optType = 'IdentityInfoDataLoadComplete'
              } else if (item.optType == 'SYSTEM_ID_PICTURE_LOAD') {
                item.optType = 'IdentityPhotoDataLoadComplete'
              } else if (item.optType == 'SYSTEM_CAMERA_RESULT') {
                item.optType = 'Take PhotoAuthResult'
              } else if (item.optType == 'CLICK_ID_PICTURE_SUBMIT_1') {
                item.optType = 'ClickFront'
              } else if (item.optType == 'ID_PICTURE_SUBMIT_1_T') {
                item.optType = 'FrontTake PhotoSuccess'
              } else if (item.optType == 'ID_PICTURE_SUBMIT_1_F') {
                item.optType = 'FrontTake PhotoFailed'
              } else if (item.optType == 'CLICK_ID_PICTURE_SUBMIT_2') {
                item.optType = 'ClickBack'
              } else if (item.optType == 'ID_PICTURE_SUBMIT_2_T') {
                item.optType = 'BackTake PhotoSuccess'
              } else if (item.optType == 'ID_PICTURE_SUBMIT_2_F') {
                item.optType = 'BackTake PhotoFailed'
              } else if (item.optType == 'ID_PICTURE_UPLOAD') {
                item.optType = 'StartUploadID Card'
              } else if (item.optType == 'ID_PICTURE_UPLOAD_NP') {
                item.optType = 'MainProductFirst LoanPageNoID CardPhotoDisplayWhen,UserSelectPhotoAfter,UploadID Card'
              } else if (item.optType == 'CLICK_ID_FACE_SUBMIT') {
                item.optType = 'ClickFace'
              } else if (item.optType == 'ID_FACE_SUBMIT_T') {
                item.optType = 'FaceTake PhotoSuccess'
              } else if (item.optType == 'ID_FACE_SUBMIT_F') {
                item.optType = 'FaceTake PhotoFailed'
              } else if (item.optType == 'ID_FACE_UPLOAD_NP') {
                item.optType = 'MainProductFirst LoanPageNoFacePhotoDisplayWhen,UserSelectPhotoAfter,UploadFace'
              } else if (item.optType == 'CLICK_ID_INF_SUBMIT') {
                item.optType = 'ClickIdentityInfoSubmitButton'
              } else if (item.optType == 'CLICK_ID_INF_SUBMIT_NP') {
                item.optType = 'MainProductFirst LoanPageNo DisplayIdentityInfoWhen,UserFillInfoAfter,ClickSubmitAndPassVerification'
              } else if (item.optType == 'SYSTEM_ID_INF_BACK') {
                item.optType = 'IdentityInfoBackPrevious'
              } else if (item.optType == 'SERVICE_UPLOAD_IDENTITY_CARD') {
                item.optType = 'SaveID CardFrontBackSuccess'
              } else if (item.optType == 'SERVICE_FIRST_UPLOAD_IDENTITY_CARD') {
                item.optType = 'MainProductFirst TimeSaveID CardFrontBackSuccess'
              } else if (item.optType == 'SERVICE_UPLOAD_FACE') {
                item.optType = 'SaveFaceSuccess'
              } else if (item.optType == 'SERVICE_FIRST_UPLOAD_FACE') {
                item.optType = 'MainProductFirst TimeSaveFaceSuccess'
              } else if (item.optType == 'SERVICE_SAVE_IDENTITY_INFO') {
                item.optType = 'SaveIdentityInfo'
              } else if (item.optType == 'SERVICE_FIRST_SAVE_IDENTITY_INFO') {
                item.optType = 'MainProductFirst TimeSaveIdentityInfo'
              } else if (item.optType == 'SYSTEM_BANK_CARD_ENTER') {
                item.optType = 'EnterBank CardInfo'
              } else if (item.optType == 'SYSTEM_BANK_CARD_LOAD') {
                item.optType = 'Bank CardInfoDataLoadComplete'
              } else if (item.optType == 'CLICK_BANK_CARD_BOX') {
                item.optType = 'PageNo DisplayBank CardInfoWhen,EnterPage(AndOtherInfoMergeWhenChange toClickFirstInputField)'
              } else if (item.optType == 'CLICK_BANK_CARD_NP') {
                item.optType = 'PageNo DisplayBank CardInfoWhen,UserFillInfoAfter,ClickSubmitAndPassVerification(AndOtherInfoMergeWhenChange toClickNext StepFirstInputField)'
              } else if (item.optType == 'CLICK_BANK_UPDATE_SUBMIT') {
                item.optType = 'DisbursementFailedWhen,ClickBank CardUpdateSubmitButton'
              } else if (item.optType == 'CLICK_BANK_CARD_SUBMIT') {
                item.optType = 'ClickBank CardSubmitButton'
              } else if (item.optType == 'SYSTEM_BANK_CARD_BACK') {
                item.optType = 'Bank CardBackPrevious'
              } else if (item.optType == 'CLICK_BANK_CARD_SUBMIT_T') {
                item.optType = 'UpdateBank CardInfo(alreadyExistAndChangeWhen)'
              } else if (item.optType == 'SERVICE_SAVE_BANK_CARD_INFO') {
                item.optType = 'SaveBank CardInfo'
              } else if (item.optType == 'SERVICE_FIRST_SAVE_BANK_CARD_INFO') {
                item.optType = 'MainProductFirst TimeSaveBank CardInfo'
              } else if (item.optType == 'SERVICE_FIRST_COMPLETE_INFO') {
                item.optType = 'MainProductFirst TimeCompleteMainProductDataFill'
              } else if (item.optType == 'SYSTEM_LOADING_ENTER') {
                item.optType = 'EnterWait'
              } else if (item.optType == 'SYSTEM_LOADING_NEXT') {
                item.optType = 'WaitRedirectNext'
              } else if (item.optType == 'SYSTEM_LOAN_ENTER') {
                item.optType = 'EnterAmountTerm'
              } else if (item.optType == 'SYSTEM_LOAN_LOAD') {
                item.optType = 'AmountTermDataLoadComplete'
              } else if (item.optType == 'CLICK_LOAN_AMOUNT') {
                item.optType = 'AmountTermEditAmount(IncludingAutoSelect)'
              } else if (item.optType == 'CLICK_LOAN_TERM') {
                item.optType = 'AmountTermEditTerm(IncludingAutoSelect)'
              } else if (item.optType == 'SYSTEM_LOCATION_RESULT') {
                item.optType = 'LocationAuthResult'
              } else if (item.optType == 'CLICK_LOAN_SUBMIT') {
                item.optType = 'AmountTermClickConfirmButton'
              } else if (item.optType == 'SYSTEM_LOAN_BACK') {
                item.optType = 'AmountTermBackPrevious'
              } else if (item.optType == 'SERVICE_PRE_LOAN_SUCCESS') {
                item.optType = 'Pre-applySuccess'
              } else if (item.optType == 'CLICK_CONFIRM_SUBMIT') {
                item.optType = 'LoanConfirmClickConfirmButton'
              } else if (item.optType == 'CLICK_CONFIRM_BACK') {
                item.optType = 'LoanConfirmBackPrevious(Cancel)'
              } else if (item.optType == 'FIRST_LOAN_SUCCESS') {
                item.optType = 'MainProductFirst LoanApplySuccess'
              } else if (item.optType == 'SERVICE_LOAN_SUCCESS') {
                item.optType = 'ApplySuccess'
              } else if (item.optType == 'SERVICE_FIRST_LOAN_SUCCESS') {
                item.optType = 'MainProductFirst LoanApplySuccess'
              } else if (item.optType == 'SERVICE_FIRST_RISK_SUCCESS') {
                item.optType = 'MainProductFirst LoanRisk ControlReviewPass'
              } else if (item.optType == 'SERVICE_FIRST_RISK_FAILUD') {
                item.optType = 'MainProductFirst LoanRisk ControlReviewReject'
              } else if (item.optType == 'SERVICE_FIRST_LOAN_FINISH') {
                item.optType = 'MainProductFirst LoanDisbursementSuccess(WithApplyAmount)'
              } else if (item.optType == 'SERVICE_FIRST_START_OVERDUE') {
                item.optType = 'MainProductFirst LoanFirst TimeOverdue'
              } else if (item.optType == 'SERVICE_FIRST_START_BAD_DEBT') {
                item.optType = 'MainProductFirst LoanFirst TimeBad Debt(Overdue90Days)'
              }*/
              })
            }
            this.loading = false
            this.visdialog = true
          })
          .catch((e) => {
            this.loading = false
            this.$message.error(e.message)
          })
      }
      for (let i = 0; i < this.custInfoIdList.length; i++) {
        if (this.custInfoIdList[i] == id) {
          this.nextId = this.custInfoIdList[i + 1]
          this.previousId = this.custInfoIdList[i - 1]
        }
      }
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {
      this.loading = true
      var params = this.getQueryParams() // Query conditions
      getAsInfo(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.dataSource = res.data || []
            if (this.dataSource != null) {
              this.dataSource.forEach((item) => {
                this.custInfoIdList.push(item.id)
                item.birthday = this.transformTime(item.birthday)
                item.createdTime = this.transformTime(item.createdTime)
                item.updatedTime = this.transformTime(item.updatedTime)
                if (item.sex == 0) {
                  item.sex = 'Confidential'
                } else if (item.sex == 1) {
                  item.sex = 'Male'
                } else if (item.sex == 2) {
                  item.sex = 'Female'
                }
                if (item.reborrowFlag == 0) {
                  item.reborrowFlag = 'No'
                } else {
                  item.reborrowFlag = 'Yes'
                }
                if (item.faceVerified == 0) {
                  item.faceVerified = 'notPass'
                } else {
                  item.faceVerified = 'Pass'
                }
              })
            }
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
      getAsCountRate(Object.assign({}, params))
        .then((res) => {
          this.countRateList = res.data
          if (this.countRateList != null) {
            this.countRateList.forEach((item) => {
              item.transRate = item.transRate + '%'
            })
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformTimeSecond(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { registerTime } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: this.transformTime(registerTime),
        endDate: this.transformTime(registerTime),
      }
      delete data.applyDate
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.registerTime = undefined
      that.queryParam.appssid = 'Please select'
      that.queryParam.translateStatus = undefined
      that.queryParam.mobileNo = undefined
      that.dataSource = []
      that.countRateList = []
      that.optTypeList = []
    },
    changeModal(visible) {
      this.visible = visible
    },

    rowClassName(record, index) {
      var date = new Date(record.curDate)
      var day = date.getTime() / 24 / 60 / 60 / 1000 + 3

      if ((day % 7) + 1 == 7) {
        return 'table_weekendColor'
      }
      return ''
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
